module.exports = __webpack_public_path__ + "static/media/bg.76d51a18.jpg";